import React from 'react';
import ImageZoom from 'react-image-zooom';

import pictoClose from "../assets/images/close.svg";
export const PopupImage = ({closePopupImage, imageCourante, imageScroll}) => {
    return (
        <div id="popup-image" className="plan-coupe-interactif off h-100 bg-architecture position-absolute bottom-0 p-4 d-flex">
            <div className="col-12 flex-grow-1 bg-white rounded-4 h-100 p-3 p-xl-4 d-flex flex-column">
                <div className="d-flex flex-column pb-3 mb-4 border-bottom border-architecture border-2">
                    <div className="d-flex align-items-center justify-content-start position-relative">
                        <div className="mini-popup-carte-picto bg-architecture rounded-3 ratio-11 d-flex align-items-center justify-content-center position-absolute start-0 overflow-hidden">
                        </div>
                        <div className="dotted-pattern dotted-pattern-purple dotted-pattern-simple"></div>
                        <div className="d-flex flex-column justify-content-center text-start lh-sm px-3">
                            { imageCourante.titre &&
                            <span className="fw-b fs-5">{imageCourante.titre}</span>
                            }
                            { imageScroll.titre &&
                                <span className="fw-b fs-5">{imageScroll.titre}</span>
                            }
                            { imageCourante.source &&
                                <span className="text-muted text-spectral">Source : {imageCourante.source}</span>
                            }
                            { imageScroll.source &&
                                <span className="text-muted text-spectral">Source : {imageScroll.source}</span>
                            }
                        </div>
                        <button className="toggle-btn ms-auto" onClick={closePopupImage}>
                            <img src={pictoClose} />
                        </button>
                    </div>
                </div>
                { imageCourante.src &&
                    <div className="col-plan col-12 flex-grow-1 d-flex flex-wrap">
                        <ImageZoom className="w-100 h-100 object-fit-contain img-fluid" src={imageCourante.src} />
                    </div>
                }
                { imageScroll.src &&
                    <div className="col-plan col-12 flex-grow-1 d-flex flex-wrap overflow-auto">
                        <img className="w-100" src={imageScroll.src} />
                    </div>
                }
            </div>
        </div>
    );
}


